function initMobileMenu(){
    //Mobi menu
    $('body .hamburger').on('click',function () {
        $('.navbar-mobile').removeClass('init');
        $('body').toggleClass('mobi-menu-open');
        $(this).toggleClass('is-active');
        if($(this).hasClass('is-active')){
            $('.navbar-mobile').removeClass('fade-out');
            $('.navbar-mobile').addClass('fade-in');
        }else{
            $('.navbar-mobile').removeClass('fade-in');
            $('.navbar-mobile').addClass('fade-out');
        }
        $.scrollLock();
    })

    initScrollBehavior()
}
function initScrollBehavior() {
    var navControl = $('header .nav-control');
    $(window).resize(function () {
        if (window.matchMedia("(min-width: 992px)").matches) {
            navControl.addClass('desktop');
            navControl.removeClass('mobile');
            navControl.removeClass('bg-white');
        }else{
            navControl.addClass('mobile');
            navControl.removeClass('desktop');
        }
    });

    $(document).on('scrollUp', function () {
        if (window.matchMedia("(max-width: 992px)").matches) {
            navControl.animate({
                top: 0
            }, 150)
        }
        if($(window).scrollTop() < 150) {
            navControl.removeClass('bg-white');
        }

    });
    //add bg if the document is not loaded at top
    if (window.matchMedia("(max-width: 992px)").matches) {
        if ($(window).scrollTop() > 100) {
            navControl.addClass('bg-white');
        }
    }
    $(document).on('scrollDown', function () {
        if (window.matchMedia("(max-width: 992px)").matches) {
            if ($(window).scrollTop() > 100) {
                navControl.animate({
                    top: (navControl.first().outerHeight() + 15) * -1
                }, 200,function () {
                  navControl.addClass('bg-white');
                });
            }
        }
    });
}